var kosan = kosan || {};

kosan.header = new function () {
    var self = this;

    this.init = function(){
        self.megaDropdown();
        self.mobileDropdown();
    };
    this.hideMegamenu = function() {
        $(".mega-dropdown").slideUp();
        $(".mega-dropdown").slideUp();
        $(".mega-dropdown").removeClass('active');
        $('.dropdown-trigger').removeClass('active');
        $('.overlay').css("visibility", "hidden");
    }
    this.megaDropdown = function (callback) {
        var dropdown = $('.mega-dropdown');
        var dropdownTrigger = $('.dropdown-trigger');

        dropdownTrigger.hoverIntent(function (e) {
            e.preventDefault();

            var ddContainer = $('.dd-content', dropdown);
            var trigger = $(this);
            var container = $(trigger).closest('.trigger-container');
            var content = $('.dropdown-content', container).html();

            if (!$(trigger).hasClass('active')) {

                if (!$(dropdown).hasClass('active')) {
                    $(dropdown).addClass('active');
                    $(dropdown).slideDown();
                }

                dropdownTrigger.removeClass('active');

                $(trigger).addClass('active');
                $(ddContainer).html(content);

            }

            $('.dd-close', dropdown).click(function () {
                $(dropdown).slideUp();
                $(dropdown).removeClass('active');
                dropdownTrigger.removeClass('active');
                $('.overlay').css("visibility", "hidden");
            });

            $('.overlay').css("visibility", "visible");
        });
        $('.overlay').click(function () {
            dropdown.slideUp();
            dropdown.removeClass('active');
            dropdownTrigger.removeClass('active');
            $('.overlay').css("visibility", "hidden");
        });
        
    }

    this.mobileDropdown = function () {
        //open the parents of the active class in the dropdown
        $("#navigation-list").find("a.active").each(function () {
            $(this).parents(".sub-dropdown, .sub-dropdown-toggle").each(function () {
                $(this).addClass("open");
            });
        })

        // Fix dropdown in dropdown issue (sub sub nav)
        $('ul.dropdown-menu [data-toggle=dropdown]').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).parent().siblings().removeClass('open');
            $(this).parent().toggleClass('open');
        });
        // Don't close dropdown on link click
        $('ul.dropdown-menu a:not(.dropdown-toggle)').on('click', function(e) {
            e.stopPropagation();
        });
        //de-collpase nav-menues to not open together
        $('.navbar-collapse').on('show.bs.collapse', function () {
          setTimeout(function(){ $("#navigation-list").find("a.active").each(function () {
              $(this).parents(".sub-dropdown, .sub-dropdown-toggle").each(function () {
                  $(this).addClass("open");
              });
          }) }, 1);

            $('.navbar-collapse').each(function () {
                if ($(this).hasClass('in')) {
                    $(this).collapse('toggle');
                }
            });
        });
        $('.navbar-collapse').on('shown.bs.collapse', function () {
            $("body").css("position", "fixed");
        });

        $('.navbar-collapse').on('hidden.bs.collapse', function () {
            $("body").css("position", "relative");
            $("#navigation-list").find("a.active").each(function () {
                $(this).parents(".sub-dropdown, .sub-dropdown-toggle").each(function () {
                    $(this).addClass("open");
                });
            })
        });
    };
}